import { render } from "./RangeTab.vue?vue&type=template&id=0b955235&scoped=true&ts=true"
import script from "./RangeTab.vue?vue&type=script&lang=ts"
export * from "./RangeTab.vue?vue&type=script&lang=ts"

import "./RangeTab.vue?vue&type=style&index=0&id=0b955235&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b955235"]])

export default __exports__